import React from 'react';
export default React.createContext({
    autosave: () => {},
    adminApi: null,
    adminTenant: null,
    clearApplicationSession: () => {},
    clearForceShowErrors: () => {},
    externalMode: false,
    fetchValuesOnSearch: () => {},
    formMessages: {},
    getApplicationFee: () => {},
    getRedirectUrl: () => {},
    getPaymentStatus: () => {},
    globalSettings: {},
    importAdminMode: false,
    inquiryMode: false,
    isSubmitted: () => {},
    isPaymentPending: () => {},
    onLeavePreview: () => {},
    onViewStager: () => {},
    previewMode: false,
    prospect: {},
    save: () => {},
    savePayment: () => {},
    selectedLocale: '',
    setProspect: () => {},
    setSelectedLocale: () => {},
    submit: () => {},
    supplementalFormMode: false,
    template: { pages: [] },
    updateValues: () => {},
    hasPermission: null
});
